/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { CREATE_INITIAL_SUBSCRIPTION, UPGRADE_OR_DOWNGRADE_SUBSCRIPTION } from "../../gql/mutations/payment";
import { Box, Button, Card, Container, Grid, List, ListItem, ListItemIcon, ListItemText, styled, Switch, Typography, useTheme } from "@mui/material";
import { GET_ALL_PRODUCTS } from "../../gql/queries/payments";
import MainLoader from "../MainLoader/MainLoader";
import { useSelector, useDispatch } from "react-redux";
import { usePopup } from "../../context/commonPop";
import { IconCheck, IconX } from "@tabler/icons-react";
import BrushShape from "../SvgIcons/BrushShape";
import pricingImageOne from "../../Images/pricing-image/PricingPlanImgOne.png";
import pricingImageTwo from "../../Images/pricing-image/PricingPlanImgTwo.png";
import pricingImageThree from "../../Images/pricing-image/PricingPlanImgThree.png";
import pricingDarkImageOne from "../../Images/pricing-image/PricingPlanDarkImgOne.png";
import pricingDarkImageTwo from "../../Images/pricing-image/PricingPlanDarkImgTwo.png";
import pricingDarkImageThree from "../../Images/pricing-image/PricingPlanDarkImgThree.png";
import WelcomeCard from "./WelcomeCard";
import { updateUser } from "../../redux/action";
import ConfirmationPopup from "./ConfirmationPopup";
import { GetScrapyData } from "../../hooks/scrapyData";
import { useLocation, useNavigate } from "react-router";
import { subscriptionCancelQuery } from "../../gql/queries/subcriptions";

const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "calc(100vh - 70px)",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  backgroundColor: theme.palette.background.default,
  paddingBottom: "60px",
  "& .PaymentBoxWrapper": {
    "& h6": { fontSize: "18px", fontWeight: 700, marginBottom: "15px" },
    "& h2": { fontSize: "24px", fontWeight: 700, marginBottom: "15px" },
  },
  "& .HeadMainWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media screen and (max-width:600px)": {
      marginTop: "12px",
      marginBottom: "16px",
      flexDirection: "column",
      gap: "10px",
    },
    "& .HeadMainHeading": {
      fontSize: "24px",
      fontWeight: 700,
      color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
    },
    "& .HeadSwitchWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      "& p": {
        fontSize: "18px",
        fontWeight: 500,
        color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
        "& strong": {
          fontSize: "18px",
          fontWeight: 700,
          color: theme.palette.primary.main,
          position: "relative",
          "& .BrushShape": {
            position: "absolute",
            right: "0",
            bottom: "-14px",
            width: "130px",
            height: "12px",
          },
        },
      },
    },
  },
  "& .PlanBoxWrapper": {},
}));

const basePricing = [
  {
    id: 1,
    image: pricingImageOne,
    imagedark: pricingDarkImageOne,
    package: "STANDARD",
    name: "STANDARD",
    monthlyplan: 5999,
    yearlyplan: 64000,
    monthlyBtnTxt: "Upgrade",
    yearlyBtnTxt: "Upgrade",
    rules: [
      { limit: true, title: "5 Project" },
      { limit: true, title: "15,000 Site audit" },
      { limit: true, title: "15 Blog generation" },
      { limit: true, title: "15 Keyword research" },
      { limit: true, title: "15 Keyword ranking" },
    ],
    yearlyRules: [
      { limit: true, title: "5 Project / Month" },
      { limit: true, title: "15,000 Site audit / Month" },
      { limit: true, title: "15 Blog generation / Month" },
      { limit: true, title: "15 Keyword research / /Month" },
      { limit: true, title: "15 Keyword ranking / Month" },
    ],
  },
  {
    id: 2,
    image: pricingImageTwo,
    imagedark: pricingDarkImageTwo,
    package: "PREMIUM",
    name: "PREMIUM",
    monthlyplan: 7999,
    yearlyplan: 85000,
    monthlyBtnTxt: "Upgrade",
    yearlyBtnTxt: "Upgrade",
    rules: [
      { limit: true, title: "10 Project" },
      { limit: true, title: "25,000 Site audit" },
      { limit: true, title: "20 Blog generation" },
      { limit: true, title: "20 Keyword research" },
      { limit: true, title: "20 Keyword ranking" },
    ],
    yearlyRules: [
      { limit: true, title: "10 Project / Month" },
      { limit: true, title: "25,000 Site audit / Month" },
      { limit: true, title: "20 Blog generation / Month" },
      { limit: true, title: "20 Keyword research / Month" },
      { limit: true, title: "20 Keyword ranking / Month" },
    ],
  },
  {
    id: 3,
    image: pricingImageThree,
    imagedark: pricingDarkImageThree,
    package: "ENTERPRISES",
    name: "ENTERPRISES",
    monthlyplan: 21999,
    yearlyplan: 233000,
    monthlyBtnTxt: "Upgrade",
    yearlyBtnTxt: "Upgrade",
    rules: [
      { limit: true, title: "15 Project" },
      { limit: true, title: "40,000 Site audit" },
      { limit: true, title: "100 Blog generation" },
      { limit: true, title: "150 Keyword research" },
      { limit: true, title: "150 Keyword ranking" },
    ],
    yearlyRules: [
      { limit: true, title: "15 Project / Month" },
      { limit: true, title: "40,000 Site audit / Month" },
      { limit: true, title: "100 Blog generation / Month" },
      { limit: true, title: "150 Keyword research / Month" },
      { limit: true, title: "150 Keyword ranking / Month" },
    ],
  },
  {
    id: 4,
    image: pricingImageThree,
    imagedark: pricingDarkImageThree,
    package: "FREEMIUM",
    name: "FREEMIUM",
    monthlyplan: 0,
    yearlyplan: 0,
    monthlyBtnTxt: "Current Plan",
    yearlyBtnTxt: "Current Plan",
    rules: [
      { limit: true, title: "5 Project" },
      { limit: true, title: "5,000 Site audit" },
      { limit: true, title: "0 Blog generation" },
      { limit: true, title: "0 Keyword research" },
      { limit: true, title: "0 Keyword ranking" },
    ],
    yearlyRules: [
      { limit: true, title: "5 Project" },
      { limit: true, title: "5,000 Site audit" },
      { limit: true, title: "0 Blog generation" },
      { limit: true, title: "0 Keyword research" },
      { limit: true, title: "0 Keyword ranking" },
    ],
  },
];

const Payment = () => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [open, setOpen] = useState(false);
  const [plans, setPlans] = useState(basePricing);
  const [loading, setLoading] = useState(true);
  const [isloading, isSetLoading] = useState(false);

  const { userData } = useSelector(state => state.reducer);
  const dispatch = useDispatch();
  const { handleOpen } = usePopup();
  const [createInitialPayment] = useMutation(CREATE_INITIAL_SUBSCRIPTION);
  const [initUpgradeOrDowngrade] = useMutation(UPGRADE_OR_DOWNGRADE_SUBSCRIPTION);
  const [CANCEL_QUERY] = useLazyQuery(subscriptionCancelQuery);
  const [getProducts] = useLazyQuery(GET_ALL_PRODUCTS, { fetchPolicy: "network-only" });

  const theme = useTheme();
  const userSubscription = userData?.subscriptionCredits?.subscriptionType || "FREEMIUM";
  const { isVerified } = GetScrapyData();
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const fetchProducts = () => {
    getProducts({
      onCompleted: ({ getAllProducts }) => {
        const merged = basePricing.map(p => {
          const api = getAllProducts.find(item => item.name === p.name);
          if (!api) return p;
          return {
            ...p,
            monthlyplan: api.monthlyPlanAmount ?? p.monthlyplan,
            yearlyplan: api.yearlyPlanAmount ?? p.yearlyplan,
            monthlyBtnTxt: api.monthlyBtnTxt ?? p.monthlyBtnTxt,
            yearlyBtnTxt: api.yearlyBtnTxt ?? p.yearlyBtnTxt,
          };
        });
        setPlans(merged);
        setShow(userData?.isAnnualSubscription ?? false);
        setLoading(false);
      },
      onError: err => {
        console.error("Error fetching products:", err);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    if (isVerified) {
      navigate("/project-config");
    }
  }, [isVerified, navigate]);

  const loadRazorpayScript = () => {
    return new Promise((resolve, reject) => {
      if (window.Razorpay) {
        resolve();
        return;
      }
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = resolve;
      script.onerror = () => reject(new Error("Failed to load Razorpay SDK"));
      document.body.appendChild(script);
    });
  };

  const handleSubscribe = async (planName, amount, isAnnualSubscription) => {
    isSetLoading(true);
    try {
      await loadRazorpayScript();

      const { data } = await createInitialPayment({
        variables: { amount, planName, isAnnualSubscription },
      });

      const paymentData = data?.createInitialPayment;
      if (!paymentData) {
        handleOpen(true, "Payment init failed");
        isSetLoading(false);
        return;
      }

      dispatch(
        updateUser({
          ...userData,
          isAnnualSubscription,
          razorpaySubscriptionId: paymentData.subscriptionId,
        }),
      );

      const orderAmountRupees = Number(paymentData.amount);
      if (Number.isNaN(orderAmountRupees)) {
        console.error("Invalid amount from backend:", paymentData.amount);
        handleOpen(true, "Invalid amount");
        isSetLoading(false);
        return;
      }

      const options = {
        key: paymentData.key || process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: orderAmountRupees * 100,
        currency: "INR",
        name: "HotSpotseo",
        description: `${planName} plan payment`,
        order_id: paymentData.orderId,
        customer_id: paymentData.customerId,
        // redirect: true,
        recurring: 1,
        callback_url: `${process.env.REACT_APP_BACKEND_DOMAIN}razorpay/verify`,
        notes: {
          plan_name: planName,
          customer_id: paymentData.customerId,
          email: userData?.email,
        },
        prefill: {
          name: userData?.name,
          email: userData?.email,
          contact: null,
        },
        theme: { color: "#F37254" },
        method: {
          card: true,
          upi: true,
          netbanking: false,
          wallet: false,
        },
      };

      const rzp1 = new window.Razorpay(options);
      isSetLoading(false);
      rzp1.open();
    } catch (error) {
      isSetLoading(false);
      handleOpen(true, `${error.message}`);
      console.error("Error creating initial payment:", error);
    }
  };

  const handleCancelFunc = () => {
    CANCEL_QUERY({
      onCompleted: () => {
        dispatch(
          updateUser({
            ...userData,
            razorpaySubscriptionId: null,
            isAnnualSubscription: false,
            subscription: { plan: null, active: false },
            subscriptionCredits: {
              subscriptionType: "FREEMIUM",
              blogGeneration: 1,
              endTime: null,
              keywordRanking: 0,
              keywordResearch: 0,
              projects: 5,
              siteAudit: (userData?.userCrawlCredits && userData.userCrawlCredits.creditUpdated) || 5000,
              totalSiteAudit: 5000,
              totalProjects: 5,
              totalBlogGeneration: 1,
              totalKeywordResearch: 0,
              totalKeywordRanking: 0,
              totalAiBlogGenerate: 0,
              aiBlogGenerate: 0,
            },
          }),
        );
        navigate("/dashboard?menu=dashboard");
      },
      onError: err => {
        console.error("Error cancelling subscription:", err);
      },
    });
  };

  const handleOnClick = price => {
    const planName = price.name;
    if (price.package === "FREEMIUM") return;

    const planAmount = show ? price.yearlyplan : price.monthlyplan;
    const isAnnualSubscription = show;

    const currentPlanDetails = plans.find(p => p.name === userSubscription);

    // first time / freemium / no active razorpay subscription → normal checkout
    if (!currentPlanDetails || userSubscription === "FREEMIUM" || !userData?.razorpaySubscriptionId) {
      handleSubscribe(planName, planAmount, isAnnualSubscription);
      return;
    }

    let currentAmount = 0;
    if (userData?.isAnnualSubscription) {
      currentAmount = currentPlanDetails.yearlyplan;
    } else {
      currentAmount = currentPlanDetails.monthlyplan;
    }

    const isDowngrade = planAmount < currentAmount;
    const isUpgrade = planAmount > currentAmount;

    const newSelectedPlan = {
      plan: planName,
      selectedPlanName: planName,
      isDowngrade,
      isUpgrade,
      isAnnualSubscription,
    };
    setSelectedPlan(newSelectedPlan);

    setOpen(true);
  };

  const checkFunc = async () => {
    if (!selectedPlan) return;

    const planName = selectedPlan.plan;

    if (planName === "FREEMIUM") {
      handleCancelFunc();
      return;
    }

    const targetPlan = plans.find(p => p.name === planName);
    if (!targetPlan) return;

    const planAmount = selectedPlan.isAnnualSubscription ? targetPlan.yearlyplan : targetPlan.monthlyplan;

    isSetLoading(true);

    try {
      const { data } = await initUpgradeOrDowngrade({
        variables: {
          amount: planAmount,
          isAnnual: selectedPlan.isAnnualSubscription,
          planName,
        },
      });

      const result = data?.initUpgradeOrDowngrade;

      if (!result) {
        handleOpen(true, "Plan change failed");
        isSetLoading(false);
        return;
      }

      // ✅ ONLY UPDATE REDUX ON UPGRADE
      if (selectedPlan.isUpgrade) {
        dispatch(
          updateUser({
            ...userData,
            subscriptionCredits: {
              ...userData.subscriptionCredits,
              subscriptionType: selectedPlan.plan,
            },
            razorpaySubscriptionId: userData.razorpaySubscriptionId,
            isAnnualSubscription: selectedPlan.isAnnualSubscription,
          }),
        );
      }

      handleOpen(true, result.message);
      setOpen(false);
    } catch (error) {
      handleOpen(true, error.message || "Something went wrong");
    } finally {
      isSetLoading(false);
    }
  };

  const currentPlanDetails = plans.find(p => p.package === userSubscription);

  const currentPlanAmount = currentPlanDetails ? (userData?.isAnnualSubscription ? currentPlanDetails.yearlyplan : currentPlanDetails.monthlyplan) : 0;

  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          {loading ? (
            <MainLoader />
          ) : (
            <>
              <Grid container spacing={2} mt={0} sx={{ justifyContent: "center" }}>
                <Grid item xs={12} lg={12}>
                  <WelcomeCard />
                </Grid>
              </Grid>
              <Grid container spacing={2} justifyContent="center" mt={0}>
                <Grid item xs={12}>
                  <Box className="HeadMainWrapper">
                    <Typography component="h2" className="HeadMainHeading">
                      Plans & Pricing
                    </Typography>
                    <Box className="HeadSwitchWrapper">
                      <Switch checked={show} onChange={() => setShow(!show)} />
                      <Typography component="p">
                        Pay annually and{" "}
                        <Typography component="strong">
                          save up to 12% <BrushShape />
                        </Typography>
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={0}>
                {userData &&
                  plans.map((price, i) => {
                    const isCurrentPlanYearly = userData?.isAnnualSubscription;
                    const isSubscribed = userSubscription === price.package && isCurrentPlanYearly === show;
                    const planAmount = show ? price.yearlyplan : price.monthlyplan;

                    // 🔹 Check if THIS exact card is current plan
                    const isSamePlan = price.package === userSubscription;
                    const isSameBillingCycle = show === userData?.isAnnualSubscription;

                    let buttonText = show ? price.yearlyBtnTxt : price.monthlyBtnTxt;

                    if (isSamePlan && isSameBillingCycle) {
                      buttonText = "Current Plan";
                    } else if (planAmount < currentPlanAmount) {
                      buttonText = "Downgrade";
                    } else if (planAmount > currentPlanAmount) {
                      buttonText = "Upgrade";
                    }       
                    const isFreemium = price.package === "FREEMIUM";
                    const rules = show ? price.yearlyRules : price.rules;

                    return (
                      <Grid item xs={12} sm={6} lg={4} key={i}>
                        <Box className="PlanBoxWrapper">
                          <Card
                            sx={{
                              padding: "32px",
                              border: isSubscribed ? `1px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.divider}`,
                              boxShadow: "none !important",
                              backgroundColor: isSubscribed && theme.palette.primary.light,
                            }}
                          >
                            <Box
                              sx={{
                                textAlign: "center",
                                marginTop: "-32px",
                                "& img": { width: "180px", height: "auto" },
                              }}
                            >
                              {theme.palette.mode === "dark" ? (
                                <Typography component="img" src={price.imagedark} alt="" />
                              ) : (
                                <Typography component="img" src={price.image} alt="" />
                              )}
                            </Box>
                            <Typography variant="subtitle1" fontSize="16px" mb={3} fontWeight={700} color="textSecondary" textTransform="uppercase">
                              {price.package}
                            </Typography>
                            <Box mt={4}>
                              <Box display="flex">
                                <Typography variant="h4" mr="8px" mt="-12px">
                                  ₹
                                </Typography>
                                <Typography fontSize="40px" fontWeight="700">
                                  {show ? price.yearlyplan : price.monthlyplan}
                                </Typography>
                                <Typography fontSize="15px" fontWeight={400} ml={1} color="textSecondary" mt={1}>
                                  {show ? "yearly" : "monthly"}
                                </Typography>
                              </Box>
                            </Box>
                            <Box mt={2}>
                              <List>
                                {rules &&
                                  rules.map((rule, idx) => (
                                    <Box key={idx}>
                                      {rule.limit ? (
                                        <ListItem disableGutters>
                                          <ListItemIcon sx={{ color: "primary.main", minWidth: "32px" }}>
                                            <IconCheck width={18} />
                                          </ListItemIcon>
                                          <ListItemText>{rule.title}</ListItemText>
                                        </ListItem>
                                      ) : (
                                        <ListItem disableGutters sx={{ color: "grey.400" }}>
                                          <ListItemIcon sx={{ color: "grey.400", minWidth: "32px" }}>
                                            <IconX width={18} />
                                          </ListItemIcon>
                                          <ListItemText>{rule.title}</ListItemText>
                                        </ListItem>
                                      )}
                                    </Box>
                                  ))}
                              </List>
                            </Box>
                            <Button
                              sx={{
                                width: "100%",
                                mt: 3,
                                "&:focus": { outline: "none" },
                                "&:hover": {
                                  backgroundColor: isSubscribed || isFreemium ? "gray" : theme.palette.primary.dark,
                                  cursor: isSubscribed || isFreemium ? "not-allowed" : "pointer",
                                },
                              }}
                              variant="contained"
                              size="large"
                              color="primary"
                              onClick={() => !isFreemium && !isSubscribed && handleOnClick(price)}
                              disabled={isSubscribed || isloading || isFreemium}
                            >
                              {buttonText}
                            </Button>
                          </Card>
                        </Box>
                      </Grid>
                    );
                  })}
              </Grid>
              <ConfirmationPopup open={open} setOpen={setOpen} show={show} isDowngrade={selectedPlan?.isDowngrade} isUpgrade={selectedPlan?.isUpgrade} onSubmit={checkFunc} />
            </>
          )}
        </Box>
      </Container>
    </SectionWrapper>
  );
};

export default Payment;
